import { PageLoading } from 'embroil/components/loading';

<template>
  <PageLoading 
    @message="Loading content..." 
    @subtitle="Please wait while we fetch the latest data"
    class="global-loading"
  />
</template>